import {
  MonthlyReportFlyAshLValue,
  MonthlyReportNameEnum,
  ResultAndIsAbnormal,
} from '@Src/_basic/object/MonthlyReportType';
import { MonthlyReportApi } from '@Src/_basic/protocol/monthlyReport/MonthlyReportApi';
import React, { memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MonthlyReportSelect from '../components/MonthlyReportSelect';

const FlyAshLValue = () => {
  const { t: i18T } = useTranslation();
  const [tableData, setTableData] = useState<Array<MonthlyReportFlyAshLValue<ResultAndIsAbnormal<number>>>>([]);

  const selectHandler = useCallback(
    (
      factoryId: number,
      exptUnitId: number,
      startTime: number,
      endTime: number,
      specificationId?: number,
      sourceId?: number,
    ) => {
      if (!factoryId || !exptUnitId || !startTime || !endTime || !specificationId) return;

      MonthlyReportApi.getFlyAshLValue(
        {
          factoryId,
          exptUnitId,
          startTime,
          endTime,
          specificationId,
          ...(sourceId && { sourceId }),
        },
        (_data) => setTableData(_data),
      );
    },
    [],
  );

  return (
    <MonthlyReportSelect
      title={i18T('REPORT.MONTHLY_REPORT.FLY_ASH_L_VALUE.TITLE')}
      exptType={MonthlyReportNameEnum.FLY_ASH_L_VALUE}
      selectHandler={selectHandler}
      tableData={tableData}
    />
  );
};

export default memo(FlyAshLValue);
